import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getLoanEligibilityReport: (params: ParamsModel = {page: 1, limit: 15}) => ({
    type: actionTypes.GET_LOAN_ELIGIBILITY_REPORT_START,
    payload: params,
  }),
  getLoanEligibilityReportSuccess: (data: any) => ({
    type: actionTypes.GET_LOAN_ELIGIBILITY_REPORT_SUCCESS,
    payload: data,
  }),
  getLoanEligibilityReportFinish: () => ({
    type: actionTypes.GET_LOAN_ELIGIBILITY_REPORT_FINISH,
  }),
}
